import {connect} from 'react-redux';
import ReviewsCount, {ReviewsCountProps} from './ReviewsCount';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState): Partial<ReviewsCountProps> => {
   return {
      reviewsCount: state.ownedReviewsCount,
      maxReviewsCount: state.authorization.quotas.reviews || 0,
      themeName: state.themeName
   };
};

export default connect(mapStateToProps, null)(ReviewsCount);
